/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
// import useData from '../../components/hooks/useData'
import Topbar from '../../components/common/topbar/Topbar'
import { Integrator, TableAction, TableDetailCell, TableHeaderCell } from '../../model/models-module'
import { addParam } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { Button, Checkbox, CircularProgress, FormControlLabel} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close'
import classes from './Integrators.module.css'
import { GridDTO } from '../../model/dto-module'
import axios from 'axios';
import AxiosInterceptor from '../../services/http/AxiosInterceptor'
import NewsanIcons from '../../components/common/Icons'
import PopupSuccessError from '../../components/common/popup-success-error/PopupSuccessError'
import { useNavigate } from 'react-router-dom'
import ConfirmDialog from '../../components/common/confirm-dialog/ConfirmDialog'

const Integrators = () => {
  const client = AxiosInterceptor.addInterceptor(process.env.REACT_APP_API_BASE_URL)
  const navigate = useNavigate();
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [baseEndpoint, setBaseEndpoint] = useState<string>('/integrators');  
  const [endpoint, setEndPoint] = useState<string>('');
  const [params] = useState<Map<string,string>>(new Map());
  const [loading, error, dataGrid] = useData<GridDTO<Integrator>>(endpoint, 'GET', undefined);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [errorResponse, setErrorResponse] = useState<string[] | null>(null);
  const [dataResponse, setDataResponse] = useState<string | null>(null);
  const [isFieldPopup, setIsFieldPopup] = useState<boolean>(false);
  const [selectedDescription, setSelectedDescription] = useState<string>('');
  const [selectedApi, setSelectedApi] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [newEditItem, setNewEditItem] = useState<Integrator | undefined>();
  const [showForm, setShowForm] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedIntegratorId, setSelectedIntegratorId] = useState<number | null>(null);


  useEffect(()=> {
    if (baseEndpoint == '') setBaseEndpoint('/integrators')
  }, [baseEndpoint])

  useEffect(()=> {
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    setDataShow([])
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  useEffect(()=> {
    if(dataHeader.length === 0 ) {
      setDataHeader([
        new TableHeaderCell({label: 'Integrador', key: 'description', sorteable: false}),
        new TableHeaderCell({label: 'Integración API', key: 'api', sorteable: false}),
      ])  
    }
  })

  const fetchData = async ( body?: {description: string, api: boolean}) => {
    try{
      setLoadingResponse(true)
      if (isEdit){
        await client.patch(`/integrators/${newEditItem?.id}`, body)
        setDataResponse('Modificado con éxito!')
        setErrorResponse(null)
        setIsEdit(false)
        setNewEditItem(undefined)
      }else{
        await client.post('/integrators', body)
        setDataResponse('Creado con éxito')
        setErrorResponse(null)
      }
      formatForm()
      setShowForm(false)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      setLoadingResponse(false);
    } 
  }
  const formatForm = () => {
    setSelectedDescription('');
    setSelectedApi(false)
  }

  const saveFormInfo = () => {
    // Validar campos del formulario
    if (!selectedDescription){
      alert('Se deben completar todos los campos')
    } else {
      const temporalObject: {description: string, api: boolean} = {
        description: selectedDescription,
        api: selectedApi
      }
      setShowPopup(true);
      fetchData(temporalObject)
    }
  }

  const deleteTemplateConfig = async (id: number) => {
    try{
      setLoadingResponse(true)
      await client.delete(`/integrators/${id}`)
      setDataResponse('Eliminado con éxito!');
			setErrorResponse(null);
		} catch (error) {
			if (axios.isAxiosError(error)) {
				setErrorResponse([error.response?.data.message]);
			} else if (error instanceof Error) {
				setErrorResponse([error.message]);
			} else {
				setErrorResponse(['Hubo un error en la solicitud']);
			}
		} finally {
			setLoadingResponse(false);
		}
  }

  useEffect(()=>{
    if(!loading && dataGrid) {
      console.log(dataGrid)
      setCountItems(dataGrid.count)
      setDataShow(dataGrid.results.map((r, index) => {
        return new TableDetailCell(r, [
          new TableAction({label: 'Eliminar', action: async () => {
            await handleDeleteClick(r.id);
          },
          icon: NewsanIcons.DELETE
          }),
          new TableAction({label: 'Editar', action: () => {
            formatForm()
            setNewEditItem(r)
            setIsEdit(true)
            setShowForm(true)
          }, icon: <span className={classes.editIcon}><EditIcon></EditIcon></span>}),
        ],
        new Map<string, React.ReactNode>([
            ['api',
            <div key={index + 'api'}>
              <Checkbox disabled checked={r.api}></Checkbox>
            </div>
          ], 
        ]), classes['storesDataTable'])
      }))
    }
  }, [setDataShow, dataGrid, loading]);

  useEffect(()=>{
    if(newEditItem && isEdit){
      setSelectedDescription(newEditItem.description);
      setSelectedApi(newEditItem.api)
    }
  }, [newEditItem, isEdit]);

  function reloadTable() {
    setBaseEndpoint('')
    setEndPoint('')
  }

  const handleDeleteClick = (relationId: number) => {
    setSelectedIntegratorId(relationId);
    setOpenConfirmDialog(true);
  };

  const confirmDelete = async () => {
    if (selectedIntegratorId !== null) {
      setIsFieldPopup(false)
      setShowPopup(true);
      setOpenConfirmDialog(false);
      await deleteTemplateConfig(selectedIntegratorId);
      setSelectedIntegratorId(null);
    }
  };

  return (
    <div className={classes.errorTransactionPage}>
      {
        loading || loadingResponse ?
        <div className='loadingPage'>
          <CircularProgress className='circleProgress'/>
        </div>
        : null
      }
      <div className={classes.storesPage}>
      <Topbar title={'Integradores'} hasReloadIcon reloadPage={reloadTable} />
      <div
        className={
          showForm ? classes['table-templates-container-form-visible'] : classes['table-templates-container']
        }
        >
          <DataTable
            headers={dataHeader}
            rows={dataShow}
            countItems={countItems}
            rowsPerPage={dataTo}
            hasActions={true}
            appendOnScrollToBottom={false}
            onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); }}
            onPageChange={(page: number)=>{ setDataOffset(page-1) }}
            pageSelected={dataOffset+1}
            pageable={true}
            selectable={false}
            className={classes.storesDataTable}
          ></DataTable>
        </div>
      {showForm ? (
        <div className={classes['abm-container']}>
          <div className={isEdit ? classes['edit-form-container'] : classes['add-form-container']}>
            <span className={classes['title-form']}>
              {NewsanIcons.ADD_OUTLINED}{' '}
              <span className={classes['title-form-text']}>{isEdit ? 'Editar' : 'Agregar'} </span></span>
            <CloseIcon
              className={classes['form-close-button']}
              onClick={() => {
                formatForm()
                setShowForm(false)
                setIsEdit(false)
                setNewEditItem(undefined)
              }}
            ></CloseIcon>
            <span className={classes['setting-attr-title']}>Nombre del integrador*</span>
            <input
              type='text'
              className={classes['setting-attr-input']}
              placeholder='Nombre del integrador'
              defaultValue={selectedDescription}
              onChange={(e) => {
                setSelectedDescription(e.target.value);
              }}
              value={selectedDescription}
              onInput={(e) => {
                const value = (e.target as HTMLInputElement).value;
                if(value == '') setSelectedDescription(value);
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedApi}
                  onChange={(event) => setSelectedApi(event.target.checked)}
                />
              }
              label="Integración Api"
              labelPlacement="start"
              className={classes.checkFieldForm}
            />
            <div className={classes['buttons-container']}>
              <Button
                variant='contained'
                className={classes['btn-newsan-cancel']}
                onClick={() => {
                  setShowForm(false)
                  setIsEdit(false)
                  setNewEditItem(undefined)
                  setDataResponse(null)
                  setErrorResponse(null)
                  formatForm()
                }}
              >
                Cancelar
              </Button>
              <Button
                variant='contained'
                onClick={async() => {await saveFormInfo();}}
                className={
                  isEdit ? classes['button-newsan-red'] : classes['button-newsan-grey']
                }
              >
                {isEdit ? 'Guardar' : 'Cargar'}
              </Button>
            </div>
          </div>
        </div>
      ) : (
          <span className={classes['btn-show-form']} onClick={() => setShowForm(!showForm)}>
            {NewsanIcons.ADD_OUTLINED}
          </span>
      )}
      </div>
        <ConfirmDialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={confirmDelete}
          title="Confirmar eliminación"
          message="¿Está seguro de que desea eliminar esta configuración?"
        />
        {showPopup ? (<PopupSuccessError
          open={showPopup}
          onClose={() =>{ 
            setShowPopup(false);
            setDataResponse(null)
            setBaseEndpoint(errorResponse == null ? '' : baseEndpoint)
            setErrorResponse(null)
            setIsFieldPopup(true)
          }}
          isFieldPopup={isFieldPopup}
          loading={loadingResponse}
          success={dataResponse !== null}
          successMessage={dataResponse}
          errorMessage={errorResponse}
        />)
      :
      <></>}
    </div>
  )
}

export default Integrators;
